export default __webpack_public_path__ + "static/media/11af814b44eba0e38a8bfc1be587b2451578681897180.14eda516.webp";